import { Grid, styled } from "@mui/material";

type CardGridProps = {
  children: React.ReactNode;
  background?: string;
  padding?: number;
  sx?: any;
  sm?: any;
  xs?: any;
  center?: boolean;
  onClick?: () => void;
};

const CardGrid = ({
  children,
  background,
  padding,
  sx,
  sm,
  xs,
  center,
  onClick,
}: CardGridProps) => {
  return (
    <StyledCardGrid
      $background={background}
      $padding={padding}
      $center={center}
      sx={sx}
      xs={xs}
      sm={sm}
      onClick={onClick}
    >
      {children}
    </StyledCardGrid>
  );
};

const StyledCardGrid = styled(Grid)<{
  $background?: string;
  $padding?: number;
  $center?: boolean;
  $border?: string;
}>`
  background: ${(props) =>
    props.$background === "indigo"
      ? "#5B41FF"
      : props.$background === "papaya"
      ? "#FF7C3A"
      : props.$background === "white"
      ? "#fff"
      : ""};
  padding: ${(props) => (props.$padding ? `${props.$padding}rem` : "")};
  border-radius: 16px;
  border: 3px solid #edf0fe;

  ${({ $center }) =>
    $center &&
    `
    display: flex;
    flex-wrap: wrap;
    justify-content: center;`};
`;

export default CardGrid;
